module.exports = __webpack_public_path__ + "assets/eeb345d94442d470940ded36ddb2f10f.mp3";